import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { CdxApiGatewayHttpService } from '../../shared/services/cdx-api-gateway-http.service';
import { Endpoints } from './endpoints';

@Injectable({
  providedIn: 'root',
})
export class DisclosureAnalyticsService {
  private http = inject(CdxApiGatewayHttpService);

  public checkDisclosureAnalytics(analyticsTab: any | any): Observable<object> {
    return this.http.post(
      Endpoints.COLLATERAL_ANALYZER_DISCLOSURE_ANALYTICS_ENDPOINT,
      JSON.stringify(analyticsTab),
    );
  }

  public checkONPREMDisclosureAnalytics(analyticsTab: any | any): Observable<object> {
    return this.http.post(
      Endpoints.ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_ANALYTICS_ENDPOINT,
      JSON.stringify(analyticsTab),
    );
  }
}
